import React from 'react';
import YoutubeEmbed from '../YoutubeEmbed/YoutubeEmbed';
import './About.css';
import '../../index.css';

/**
This component is for the home screen of the webpage when the user isn't logged in
*/
class About extends React.PureComponent {
  render() {
    return (
      <div className="section">
        <h1 className="second-header">Learn More about Run Legends</h1>
        <div className="video-wrapper">
          <YoutubeEmbed embedId="NDHYsr2pa5c" />
        </div>
      </div>
    );
  }
}
export default About;
